import { z } from "zod";
import { PaymentModeSchema } from "./order.entity.ts";
import { Id } from "./workspace.entity.ts";

// This fresh nonce comes from the callback fragment, not the original OAuth
// state. The server also requires the initiating member's current MFA session
// and organization authority before any token exchange or merchant activation.
export const FinishRevolutConnectionInput = z
	.object({
		orgId: Id,
		env: PaymentModeSchema,
		nonce: z.string().regex(/^[A-Za-z0-9_-]{43}$/),
	})
	.strict();
export type FinishRevolutConnectionInput = z.infer<
	typeof FinishRevolutConnectionInput
>;

export const FinishRevolutConnectionOutput = z
	.object({ ok: z.literal(true) })
	.strict();
export type FinishRevolutConnectionOutput = z.infer<
	typeof FinishRevolutConnectionOutput
>;
